import { render } from "./AddEditItemModal.vue?vue&type=template&id=3f8897aa&scoped=true"
import script from "./AddEditItemModal.vue?vue&type=script&lang=js"
export * from "./AddEditItemModal.vue?vue&type=script&lang=js"

import "./AddEditItemModal.vue?vue&type=style&index=0&id=3f8897aa&lang=less&scoped=true"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f8897aa"]])

export default __exports__